import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import httpHelper, {Method_TYPE}  from 'utils/http-helper';
import URL_CONSTANTS from 'constants/url-constants';

const LoginForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    emailOrMobile: '',
    password: ''
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [regSystem, setRegSystem] = useState('Gents');

  // Mock credentials for authentication
  const mockCredentials = {
    admin: { emailOrMobile: 'admin@prasanthiseva.org', password: 'admin123' },
    coordinator: { emailOrMobile: 'coordinator@prasanthiseva.org', password: 'coord123' },
    leader: { emailOrMobile: '9876543210', password: 'leader123' }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.emailOrMobile.trim()) {
      newErrors.emailOrMobile = 'Email or mobile number is required';
    }

    if (!formData.password.trim()) {
      newErrors.password = 'Password is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setIsLoading(true);

    try {
      const body = {username : formData.emailOrMobile, password: formData.password }
      const data = await httpHelper(URL_CONSTANTS.LOGIN,Method_TYPE.POST,body);
  
      // Handle successful login, e.g., store token and navigate
      localStorage.setItem('authToken', data.token);
      localStorage.setItem('role', data.role);
      setIsLoading(false);
      setPasswordVisible(false)
      navigate('/dashboard');
    } catch (error) {
      console.log(error)
      setErrors({
      general: 'Login failed. Please try again later.',
      });
      setIsLoading(false);
    }

    // Simulate API call
    // setTimeout(() => {
    //   const isValidCredentials = Object.values(mockCredentials).some(
    //     cred => cred.emailOrMobile === formData.emailOrMobile && cred.password === formData.password
    //   );

    //   if (isValidCredentials) {
    //     localStorage.setItem('authToken', 'mock-jwt-token');
    //     localStorage.setItem('userRole', 'admin');
    //     navigate('/dashboard');
    //   } else {
    //     setErrors({
    //       general: 'Invalid credentials. Please use: admin@prasanthiseva.org / admin123 or coordinator@prasanthiseva.org / coord123 or 9876543210 / leader123'
    //     });
    //   }
      
    //   setIsLoading(false);
    // }, 1500);
  };

  const handleClickPasswordVisibility = () => {
    setPasswordVisible((prevState) => !prevState);
  };

  useEffect(() => {
    const hostname = window.location.hostname;
    const regSystemType = hostname.includes("mparthiseva.ssssotn.org") ? "Mahilas" : "Gents";
    setRegSystem(regSystemType);
  }, []);



  return (
    <div className="w-full max-w-md mx-auto">
      <form onSubmit={handleLogin} className="space-y-6">
        {/* Enhanced Header with High Contrast */}
        <div className="text-center mb-2">
          <div className="flex items-center justify-center mb-3">
            <div className="w-40 h-40 rounded-full flex items-center justify-center border-4 border-white/90">
              <img src="assets/images/sarvaDharma-logo.png" alt="Logo" className="w-180 h-auto" />
            </div>
          </div>
          
          {/* High Contrast Title */}
          <div className="bg-white/90 rounded-lg p-2">
            <h1 className="font-heading font-bold text-2xl text-gray-800 mb-2">
              Tamil Nadu Prasanthi Seva
            </h1>
            <p className="text-gray-600 font-caption font-medium">
              Registration Management System : {regSystem}
            </p>
          </div>
          
          {/* Blessing Text with High Contrast */}
          <div className="mt-4 p-4 bg-gradient-to-r from-spiritual-gold/10 to-spiritual-orange/10 rounded-lg border-2 border-spiritual-gold/30 shadow-md">
            <p className="text-sm text-gray-700 font-medium italic">
              "Love All, Serve All" - Sri Sathya Sai Baba
            </p>
          </div>
        </div>

        {/* Enhanced General Error Message with High Contrast */}
        {errors.general && (
          <div className="bg-white border-2 border-red-300 rounded-lg p-4 mb-6 shadow-lg">
            <div className="flex items-start space-x-3">
              <Icon name="AlertCircle" size={20} className="text-red-600 flex-shrink-0 mt-0.5" />
              <div>
                <p className="text-sm text-red-700 font-medium mb-1">Authentication Failed</p>
                <p className="text-xs text-red-600">{errors.general}</p>
              </div>
            </div>
          </div>
        )}

        {/* Form Fields with Enhanced Contrast */}
        <div className="space-y-4">
          {/* Email/Mobile Input */}
          <div>
            <Input
              type="text"
              name="emailOrMobile"
              label="Email or Mobile Number"
              placeholder="Enter email or mobile number"
              value={formData.emailOrMobile}
              onChange={handleInputChange}
              error={errors.emailOrMobile}
              required
              disabled={isLoading}
              className="bg-white border-2 border-gray-300 focus:border-spiritual-orange focus:ring-spiritual-orange/20 text-gray-800 placeholder-gray-500"
            />
          </div>

          {/* Password Input */}
          <div className='relative'>
            <Input
              type={passwordVisible ? "text" : "password"}
              name="password"
              label="Password"
              placeholder="Enter your password"
              value={formData.password}
              onChange={handleInputChange}
              error={errors.password}
              required
              disabled={isLoading}
              className="bg-white border-2 border-gray-300 focus:border-spiritual-orange focus:ring-spiritual-orange/20 text-gray-800 placeholder-gray-500"
            />
            <button
        type="button"
        className="absolute inset-y-0 top-7 right-3 flex items-center text-gray-500 hover:text-gray-700"
        tabIndex={-1} // prevents focus on tab
      >
     {passwordVisible ?  <Icon name="Eye" size={21} className="text-gray-600" onClick ={handleClickPasswordVisibility}/>:
         <Icon name="EyeOff" size={21} className="text-gray-600" onClick ={handleClickPasswordVisibility} /> }
      </button>
          </div>
        </div>

        {/* Enhanced Login Button with High Contrast */}
        <Button
          type="submit"
          variant="default"
          size="lg"
          fullWidth
          loading={isLoading}
          iconName="LogIn"
          iconPosition="left"
          disabled={isLoading}
          className="bg-spiritual-orange hover:bg-spiritual-deep-orange text-white font-medium transition-all duration-300 shadow-lg hover:shadow-xl border-2 border-spiritual-orange/50"
        >
          {isLoading ? 'Signing In...' : 'Sign In'}
        </Button>

        {/* Enhanced Additional Info with High Contrast */}
        <div className="text-center">
          <div className="bg-white/80 rounded-lg shadow-sm">
            <p className="text-xs text-gray-600 font-medium">
              For technical support, contact IT Administrator
            </p>
            <div className="mt-2 flex justify-center space-x-2">
              <div className="w-2 h-2 bg-spiritual-orange rounded-full" />
              <div className="w-2 h-2 bg-spiritual-blue rounded-full" />
              <div className="w-2 h-2 bg-spiritual-purple rounded-full" />
              <div className="w-2 h-2 bg-spiritual-gold rounded-full" />
              <div className="w-2 h-2 bg-spiritual-teal rounded-full" />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default LoginForm;